module.exports = __webpack_public_path__ + "img/icon-download.1ad2db37.svg";